<template>
    <div>
        <div :style="'background-image: url(' + branding.portraitSplashUrl + '); min-height:'+splashHeight+';'"
             class="splash"
             v-if="branding && branding.portraitSplashUrl && $vuetify.breakpoint.name == 'xs'"></div>
        <div :style="'background-image: url(' + branding.landscapeSplashUrl + '); min-height:' +splashHeight+';'" class="splash"
             v-if="branding && branding.landscapeSplashUrl && $vuetify.breakpoint.name != 'xs'"></div>

            <v-dialog max-width="290" persistent v-model="errorDialog" v-if="errorDialog">
                <v-card>
                    <v-card-title class="error white--text">Error</v-card-title>
                    <v-card-text>{{errorText}}</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="errorDialog = false" color="green darken-1" text>OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

    </div>
</template>

<script>

    import api from "../services/aggrega8-api";

    export default {
        name: 'Home',
        components: {},
        computed: {
            apiKey: function () {
                return this.$store.state.apiKey
            },
            userDetails: function () {
                return this.$store.state.userDetails
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            },
            executing: function () {
                return this.$store.state.executing
            },
            branding: function () {
                return this.$store.state.branding
            },
            splashHeight: function () {
                if (window.innerHeight) {
                    return (window.innerHeight-75) + "px"
                }
                else {
                    return "600px"
                }
            }
        },
        data: () => ({
            errorDialog: false,
            errorText: ""

        }),
        async mounted() {
            if (!this.loggedIn) {
                let token = localStorage.getItem("api_key")
                if (token) {
                    this.$store.dispatch("setApiKey", token)
                    this.$store.dispatch("setExecuting", true)
                    await api.getUserDetails()
                    this.$store.dispatch("setExecuting", false)
                }
            }
            window.scrollTo(0, 0)
        }
        ,
        methods: {

        }
    }
</script>
<style scoped>
    .splash {
        background-size: cover;
        background-position: center;
    }
</style>